import {
  ALTERNATE_EMAIL,
  EMAIL,
  EMAIL_ERR,
  EMAIL_PATTERN,
  ENTER,
  FIRST_NAME,
  FIRST_NAME_ERR,
  initialState,
  LAST_NAME,
  LAST_NAME_ERR,
  NAME_PATTERN,
} from './constants';

const createValidator = (pattern: RegExp, errorMsg: string) => {
  return (value: string) => {
    if (!value) {
      return '';
    }
    return pattern.test(value) ? '' : errorMsg;
  };
};

export const validators = {
  [EMAIL]: createValidator(EMAIL_PATTERN, EMAIL_ERR),
  [ALTERNATE_EMAIL]: createValidator(EMAIL_PATTERN, EMAIL_ERR),
  [FIRST_NAME]: createValidator(NAME_PATTERN, FIRST_NAME_ERR),
  [LAST_NAME]: createValidator(NAME_PATTERN, LAST_NAME_ERR),
};

export const validateField = (name: keyof typeof validators, value: any) => {
  const validator = validators[name];

  return validator ? validator(value) : '';
};

export const validateForm = (
  formState: typeof initialState,
  setFormState: React.Dispatch<React.SetStateAction<any>>
): boolean => {
  const updatedState = { ...formState };
  let isValid = true;

  Object.keys(updatedState).forEach((key) => {
    const field = updatedState[key as keyof typeof formState];
    if (field.required && !field.value) {
      field.error = `${ENTER} ${key}.`;
      isValid = false;
    } else {
      field.error = '';
    }
  });

  setFormState(updatedState);
  return isValid;
};
